import type { Asset } from '@schibsted-svp/svp-api-types';

import type { HttpClient, HttpClientOptions } from './httpClient';

const getPlaylist =
  (client: HttpClient) =>
  async (playlistId: string, options?: HttpClientOptions): Promise<Asset[]> => {
    const response = await client(`/${playlistId}`, options);

    const { resolved } = await response.json();

    return resolved;
  };

export const createPlaylistApi = (client: HttpClient) => {
  return {
    getPlaylist: getPlaylist(client),
  };
};

export type PlaylistApiClient = ReturnType<typeof createPlaylistApi>;
